export default function truncateString(string, maxCharacterNumber) {
  if (string.length > maxCharacterNumber) {
    return `${string.slice(0, maxCharacterNumber)}...`
  }

  return string
}
